import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'

export const StyledChatMessagesLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
`

export const StyledRegion = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-gutter: stable;
  ${s({
    px: 5,
    pt: 5,
    pb: 8,
  })}
`
